import React, { useState, useEffect } from "react";
import ItemReportsTable from "./components/item-reports-table";
import "./item-reports.css";
import Loading from "../../components/loading";
import { useNavigate, useParams } from "react-router";
import { GetReportInfo } from "../../utils/firebase-config";

const ItemReports = () => {
  const [loading, setLoading] = useState(true);
  const [report, setReport] = useState(null);
  const { reportId } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    console.log(reportId, "id");
    const fetchReport = async () => {
      const reportInfo = await GetReportInfo(reportId);
      if (reportInfo) {
        setReport(reportInfo);
        setLoading(false);
      } else {
        navigate("/error");
        return;
      }
    };
    if (reportId) {
      fetchReport();
    } else {
      // navigate("/error");
    }
  }, [reportId]);
  return (
    <div className="reports-container">
      {loading ? (
        <Loading text="Loading report..." />
      ) : report ? (
        <ItemReportsTable report={report} />
      ) : null}
    </div>
  );
};

export default ItemReports;
